export default {
  ADMIN_VIDEO_ERROR(state, payload) {
    state.error = payload
  },

  TOGGLE_LOADING(state, payload) {
    state.loading = payload
  },

  TOGGLE_LOADING_SEND_ADMIN_VIDEO_MEDIA(state, payload) {
    state.uploadLoading = payload
  },

  UPDATE_GROUP_ID(state, payload) {
    state.groupId = payload
  },

  UPDATE_UUID_ADMIN_VIDEO(state, payload) {
    state.idConfigurationVideo = payload
  },

  UPDATE_VIDEO_CONFIGURATION(state, payload) {
    state.configurations = payload
  }
}
